import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
} from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

import { FormService } from '../form.service';

@Component({
  selector: 'app-form-template-toggle-panel',
  templateUrl: './form-template-toggle-panel.component.html',
  styleUrls: ['./form-template-toggle-panel.component.scss'],
})
export class FormTemplateTogglePanelComponent implements OnChanges {
  @Input() description?: string;
  @Input() forms: any[];
  @Input() title: any;
  @Output() formChange: EventEmitter<any> = new EventEmitter();
  formGroup: UntypedFormGroup;

  constructor(private formService: FormService) {}

  ngOnChanges() {
    this._generateFormGroup(this.forms);
  }

  _generateFormGroup(forms: any[]): void {
    this.formGroup = this.formService.generateFormGroup(forms);
    this.onChanges();
  }

  onChanges(): void {
    this.formGroup.valueChanges.subscribe((form) => this.formChange.emit(form));
  }
}
